import authAxios from "../utility/authAxios"
import {API_VERSION} from "../config/axios"

export const getUserStatistics = async data => {
    return authAxios.get(API_VERSION + '/dashboard/user-statistics')
}
